import { Trans, useTranslation } from 'react-i18next';

import '../../../../components/Tooltip';
import { IOSShare } from '../../../../components/SVGIcons/IOSShare';
import { VerticalDots } from '../../../../components/SVGIcons/VerticalDots';

import styles from './InAppBlockedTooltip.module.scss';

const InAppBlockedTooltip = ({
  setTooltipRef,
  getTooltipProps,
  getArrowProps,
}: {
  setTooltipRef: any;
  getTooltipProps: any;
  getArrowProps: any;
}) => {
  const { t } = useTranslation();
  return (
    <div
      ref={setTooltipRef}
      {...getTooltipProps({
        className: 'tooltip-container',
        style: { border: '1px solid black', borderRadius: '1rem' },
      })}
    >
      <div className={styles.InAppBlockedTooltipContent}>
        <p>{t('auth.googleSignInNotSupported')}</p>
        <ul>
          <li data-testid="inapp-blocked-ios">
            <Trans components={{ bold: <b />, share: <IOSShare /> }} i18nKey="auth.inAppBlockedIos" />
          </li>
          <li data-testid="inapp-blocked-android">
            <Trans components={{ bold: <b />, dots: <VerticalDots /> }} i18nKey="auth.inAppBlockedAndroid" />
          </li>
        </ul>
      </div>
      <div {...getArrowProps({ className: 'tooltip-arrow' })} />
    </div>
  );
};

export default InAppBlockedTooltip;
